import type { IconKind } from '@saviynt/design-system';

import { SCORE_CHIP_CONFIGS } from '../constants';

type ScoreLevel = keyof typeof SCORE_CHIP_CONFIGS.SCORE_ICONS;

const getScoreLevel = (confidence: number): ScoreLevel => {
  if (confidence >= SCORE_CHIP_CONFIGS.CONFIDENCE_THRESHOLDS.HAPPY) {
    return 'HAPPY';
  }

  if (confidence >= SCORE_CHIP_CONFIGS.CONFIDENCE_THRESHOLDS.NEUTRAL) {
    return 'NEUTRAL';
  }

  return 'SAD';
};

// Helper function to get score icon based on confidence
export const getScoreIcon = (confidence: number): IconKind => {
  const level = getScoreLevel(confidence);

  return SCORE_CHIP_CONFIGS.SCORE_ICONS[level];
};

// Helper function to get score chip color
export const getScoreChipColor = (
  confidence: number
): 'success' | 'warning' | 'critical' => {
  const level = getScoreLevel(confidence);

  return SCORE_CHIP_CONFIGS.SCORE_COLORS[level];
};

// Helper function to get score chip class name
export const getScoreChipClassName = (confidence: number): string => {
  const level = getScoreLevel(confidence);

  return SCORE_CHIP_CONFIGS.SCORE_CLASSNAMES[level];
};
